<template>
  <block
    component-name="block-text-ol"
    body-class="grid grid-cols-12 gap-x-ui gap-y-3xl"
  >
    <template v-slot:default="blockData">
      <section class="w-full col-span-full laptop:col-start-1 laptop:col-end-6">
        <txt-chapter
          size="big"
          :overline="
            $attrs.data.body.overline ? $attrs.data.body.overline : undefined
          "
          :title="$attrs.data.body.title ? $attrs.data.body.title : undefined"
          :text="$attrs.data.body.text ? $attrs.data.body.text : undefined"
          :button="
            $attrs.data.body.button ? $attrs.data.body.button : undefined
          "
          class="w-full"
          :class="{
            'sticky top-30 laptop:top-40 left-0':
              $attrs.data.body.items.length > 3,
          }"
        />
      </section>

      <section
        class="w-full col-span-full laptop:col-start-7 laptop:col-end-12"
      >
        <component
          :is="$attrs.config.useMedia ? 'ul' : 'ol'"
          class="flex flex-col items-stretch list-none divide-y divide-skin-subtle border-y border-skin-subtle"
        >
          <li
            v-for="(item, index) in $attrs.data.body.items"
            class="flex items-start justify-start gap-2xl p-2xl"
          >
            <media
              v-if="$attrs.config.useMedia"
              tag="div"
              v-bind="item.asset"
              :loading="blockData?.loading || 'eager'"
              :sizes="{ base: 64 }"
              reveal="fade-from-down reveal-strong"
              fit="contain"
              class="w-[32px] min-w-[32px] max-w-[32px] grow-0"
              :use-bg="false"
            />
            <wrapper-reveal v-else reveal="fade-from-right">
              <div
                class="text-heading-5 tabular-nums"
                v-html="`${index + 1 < 10 ? '0' : ''}${index + 1}.`"
              ></div>
            </wrapper-reveal>

            <div class="flex flex-col grow gap-2xs">
              <wrapper-split-text reveal="words">
                <div class="text-heading-5" v-html="item.title"></div>
              </wrapper-split-text>

              <wrapper-reveal v-if="item.text" reveal="fade-from-bottom">
                <div class="text-body-big" v-html="item.text"></div>
              </wrapper-reveal>
            </div>
          </li>
        </component>
      </section>
    </template>
  </block>
</template>
